import { Center, Flex, Input, Loader, Text } from "@mantine/core";
import TableEdit from "./TableEdit";
import { useState } from "react";
import { IQueryFinancial, useFinancial } from "../../../hooks/useFinancial";
import { useTranslation } from "react-i18next";

const Financial = () => {
  const { t } = useTranslation();
  const [query, setQuery] = useState<IQueryFinancial>({
    page: 1,
    pageSize: 10,
  });
  const { data, isLoading } = useFinancial(query);

  return (
    <>
      <Flex
        direction="column"
        justify="start"
        align="start"
        h="100%"
        w="100%"
        gap="32px"
      >
        <Flex
          id="filtersEdit"
          w="100%"
          justify={{ base: "center", 991: "space-between" }}
          align={{ base: "start", 991: "center" }}
          gap={{ base: 24 }}
          direction={{ base: "column", 991: "row" }}
        >
          <Text
            fz={{ base: 24 }}
            fw={700}
            lh={{ base: "32px" }}
            style={{ whiteSpace: "nowrap" }}
          >
            {t("meu_perfil.financeiro.title")}
          </Text>
          <Input
            my="auto"
            maw={400}
            w="100%"
            placeholder={t("meu_perfil.financeiro.search")}
            value={query.productName}
            onChange={(e) =>
              setQuery((prev) => ({ ...prev, productName: e.target.value }))
            }
          />
        </Flex>
        {isLoading ? (
          <Center w="100%" h="200px">
            <Loader color="cyan" />
          </Center>
        ) : !!data && data?.data?.length > 0 ? (
          <TableEdit data={data} query={query} setQuery={setQuery} />
        ) : (
          <Center w="100%" h="200px">
            <Text fz={{ base: 24 }} fw={700} lh={{ base: "32px" }}>
              {t("global.pagination.no_data")}
            </Text>
          </Center>
        )}
      </Flex>
    </>
  );
};

export default Financial;
